var _mask, _mask2, _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandboxSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 15,
    maskUnits: "userSpaceOnUse",
    width: 30,
    x: 3,
    y: 3
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.3572 3.97763c.7662-.04355 1.5314-.04006 2.2976-.04006h10.7073c.7812 0 1.5464-.00349 2.3122.04006.6961.03919 1.3742.12281 2.0492.30963 1.4209.39281 2.6618 1.21326 3.5587 2.37644.8917 1.15577 1.3743 2.57066 1.3743 4.0234 0 1.4545-.4826 2.8686-1.3743 4.0243-.8969 1.1628-2.1378 1.9837-3.5587 2.3765-.675.1868-1.3531.27-2.0492.3096-.7658.0435-1.531.0396-2.2972.0396-.0053 0-10.7082.0005-10.7082.0005-.7803-.0005-1.5455.0034-2.3117-.0401-.69571-.0396-1.37381-.1228-2.04883-.3096-1.42092-.3928-2.66175-1.2137-3.55868-2.3765-.89166-1.1557-1.37469-2.5698-1.37469-4.0238 0-1.45324.48303-2.86813 1.37469-4.0239.89693-1.16318 2.13776-1.98363 3.55868-2.37644.67502-.18682 1.35312-.27044 2.04883-.30963z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 15,
    maskUnits: "userSpaceOnUse",
    width: 30,
    x: 3,
    y: 18
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.3572 18.6026c.7662-.0435 1.5314-.04 2.2976-.04h10.7073c.7812 0 1.5464-.0035 2.3122.04.6961.0392 1.3742.1228 2.0492.3097 1.4209.3928 2.6618 1.2132 3.5587 2.3764.8917 1.1558 1.3743 2.5707 1.3743 4.0234 0 1.4545-.4826 2.8686-1.3743 4.0243-.8969 1.1628-2.1378 1.9837-3.5587 2.3765-.675.1868-1.3531.27-2.0492.3096-.7658.0435-1.531.0396-2.2972.0396-.0053 0-10.7082.0005-10.7082.0005-.7803-.0005-1.5455.0034-2.3117-.0401-.69571-.0396-1.37381-.1228-2.04883-.3096-1.42092-.3928-2.66175-1.2137-3.55868-2.3765-.89166-1.1557-1.37469-2.5698-1.37469-4.0238 0-1.4532.48303-2.8681 1.37469-4.0239.89693-1.1632 2.13776-1.9836 3.55868-2.3764.67502-.1869 1.35312-.2705 2.04883-.3097z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.3573 3.97763c.7662-.04355 1.5315-.04006 2.2976-.04006h10.7073c.7812 0 1.5464-.00349 2.3122.04006.6961.03919 1.3742.12281 2.0492.30963 1.4209.39281 2.6618 1.21326 3.5587 2.37644.8917 1.15577 1.3742 2.57066 1.3742 4.0234 0 1.4545-.4825 2.8686-1.3742 4.0243-.8969 1.1628-2.1378 1.9837-3.5587 2.3765-.675.1868-1.3531.27-2.0492.3096-.7658.0435-1.5311.0396-2.2972.0396-.0053 0-10.7082.0005-10.7082.0005-.7802-.0005-1.5455.0034-2.3117-.0401-.69569-.0396-1.37379-.1228-2.0488-.3096-1.42092-.3928-2.66175-1.2137-3.55869-2.3765-.89165-1.1557-1.37469-2.5698-1.37469-4.0238 0-1.45324.48304-2.86813 1.37469-4.0239.89694-1.16318 2.13777-1.98363 3.55869-2.37644.67501-.18682 1.35311-.27044 2.0488-.30963z",
    fill: "#00df90",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m25.875 15.75c2.7959 0 5.0625-2.2666 5.0625-5.0625 0-2.79594-2.2666-5.0625-5.0625-5.0625s-5.0625 2.26656-5.0625 5.0625c0 2.7959 2.2666 5.0625 5.0625 5.0625z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3638 12.9375c.1493 0 .2662-.0614.3483-.1869l2.3283-3.69621c.0597-.09215.0846-.17662.0846-.25597 0-.2099-.1493-.36092-.3582-.36092-.1443 0-.2314.05119-.3184.19454l-2.0945 3.40956-1.0697-1.3874c-.0846-.1049-.1716-.1536-.296-.1536-.2115 0-.3632.1536-.3632.3661 0 .0921.0299.1792.107.2713l1.286 1.6254c.097.1203.204.1741.3458.1741z",
    fill: "#00593a"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.3573 18.6026c.7662-.0435 1.5315-.04 2.2976-.04h10.7073c.7812 0 1.5464-.0035 2.3122.04.6961.0392 1.3742.1228 2.0492.3097 1.4209.3928 2.6618 1.2132 3.5587 2.3764.8917 1.1558 1.3742 2.5707 1.3742 4.0234 0 1.4545-.4825 2.8686-1.3742 4.0243-.8969 1.1628-2.1378 1.9837-3.5587 2.3765-.675.1868-1.3531.27-2.0492.3096-.7658.0435-1.5311.0396-2.2972.0396-.0053 0-10.7082.0005-10.7082.0005-.7802-.0005-1.5455.0034-2.3117-.0401-.69569-.0396-1.37379-.1228-2.0488-.3096-1.42092-.3928-2.66175-1.2137-3.55869-2.3765-.89165-1.1557-1.37469-2.5698-1.37469-4.0238 0-1.4532.48304-2.8681 1.37469-4.0239.89694-1.1632 2.13777-1.9836 3.55869-2.3764.67501-.1869 1.35311-.2705 2.0488-.3097z",
    fill: "#cbcbcb",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.4062 30.375c2.9513 0 5.3438-2.3925 5.3438-5.3438 0-2.9512-2.3925-5.3437-5.3438-5.3437-2.95122 0-5.3437 2.3925-5.3437 5.3437 0 2.9513 2.39248 5.3438 5.3437 5.3438z",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandboxSwitch);
export default __webpack_public_path__ + "static/media/sandbox-switch.5296512ba6e68ddf283bb57b67f6a24d.svg";
export { ForwardRef as ReactComponent };